
import { useState, useEffect, useContext, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Spinner,
  Modal,
  Form,
  Collapse,
} from "react-bootstrap";
import { GrGroup } from "react-icons/gr";
import { BsQuestionCircle, BsThreeDotsVertical } from "react-icons/bs";
import { HiArrowRight } from "react-icons/hi";
import { MdOutlineTextsms } from "react-icons/md";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "bootstrap/dist/css/bootstrap.min.css";
import NavBar from "../../NavBar";
import { _imagesURL, adminBaseURL } from "../../../constants/API";
import { authorize } from "../../../shared/authorize";
import { Language } from "../../../App";
import place from "../../../assets/images/place.png";
import comment from "../../../assets/images/comment.svg";
import comment1 from "../../../assets/images/comment1.svg";
import photo from "../../../assets/images/photo.svg";
import dd1 from "../../../assets/images/dd1.jfif";
import dd2 from "../../../assets/images/dd2.jfif";
import { CiSearch } from "react-icons/ci";
import { AiOutlineLike, AiOutlineDislike } from "react-icons/ai";
import { BiReply } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import { LuMessageSquarePlus } from "react-icons/lu";
import { FaArrowDown } from "react-icons/fa";
import { FiTrash2 } from "react-icons/fi";
import PurchasePopup from "../../course-details/PurchasePopup";

const UserImageWithLoader = ({
  src,
  alt,
  fallbackSrc,
  size = "48px",
  className = "",
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleImageLoad = () => {
    setLoading(false);
  };

  const handleImageError = () => {
    setError(true);
    setLoading(false);
  };

  return (
    <div
      className={`rounded-circle position-relative ${className}`}
      style={{
        width: size,
        height: size,
        overflow: "hidden",
        backgroundColor: "#f0f0f0",
        flexShrink: 0,
      }}
    >
      {loading && (
        <div
          className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ zIndex: 1 }}
        >
          <Spinner
            animation="border"
            size="sm"
            style={{
              width:
                size === "48px"
                  ? "20px"
                  : size === "40px"
                    ? "18px"
                    : size === "36px"
                      ? "16px"
                      : "14px",
              height:
                size === "48px"
                  ? "20px"
                  : size === "40px"
                    ? "18px"
                    : size === "36px"
                      ? "16px"
                      : "14px",
              borderWidth: "2px",
              color: "#000",
            }}
          />
        </div>
      )}
      <img
        src={error ? fallbackSrc : src}
        onLoad={handleImageLoad}
        onError={handleImageError}
        alt={alt}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: loading ? "none" : "block",
        }}
      />
    </div>
  );
};

// Three Dots Menu Component
const ThreeDotsMenu = ({ onDelete, show = true }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!show) return null;

  return (
    <div ref={menuRef} style={{ position: "relative" }}>
      {/* Three Dots Button */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: "4px 6px",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "background-color 0.2s ease",
        }}
        onMouseEnter={(e) =>
          (e.currentTarget.style.backgroundColor = "#f0f0f0")
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.backgroundColor = "transparent")
        }
      >
        <BsThreeDotsVertical size={18} color="#6c757d" />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            right: 0,
            marginTop: "4px",
            backgroundColor: "#fff",
            borderRadius: "10px",

            border: "1px solid #dedede",
            zIndex: 100,
            minWidth: "150px",
            overflow: "hidden",
            animation: "dropdownFadeIn 0.15s ease-out",
          }}
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
              setIsOpen(false);
              onDelete();
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              width: "100%",
              background: "none",
              border: "none",
              padding: "10px 16px",
              cursor: "pointer",
              color: "#dc3545",
              fontSize: "0.9rem",
              fontWeight: "500",
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#fff5f5")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "transparent")
            }
          >
            <FiTrash2 size={16} />
            <span>Delete</span>
          </button>
        </div>
      )}
    </div>
  );
};

// Delete Confirmation Modal Component
const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, isDeleting }) => {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      backdrop="static"
      size="md"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <Modal.Body style={{ padding: "20px" }}>
        {/* Title */}
        <h5
          style={{
            fontWeight: "500",
            color: "#1a1a1a",

            fontSize: "19px",
          }}
        >
          Are you Sure You Want to Delete this Post?
        </h5>

        {/* Subtitle / Warning */}
        <p
          style={{
            color: "#6c757d",

            fontSize: "14px",
            marginBottom: "-10px",
            lineHeight: "1.5",
          }}
        >
          Once you delete this post, it can't be restored.
        </p>
      </Modal.Body>

      <Modal.Footer
        style={{
          borderTop: "none",

          display: "flex",

          gap: "12px",
        }}
      >
        {/* Cancel Button */}
        <Button
          onClick={onClose}
          style={{
            padding: "10px 28px",
            fontSize: "0.92rem",
            minWidth: "100px",
            borderRadius: "8px",
            fontWeight: "600",
            backgroundColor: "transparent",
            border: "1px solid #d1d5db",
            color: "#374151",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f3f4f6")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        >
          Cancel
        </Button>

        {/* Yes, Delete Button */}
        <Button
          onClick={onConfirm}
          disabled={isDeleting}
          style={{
            padding: "10px 20px",
            fontSize: "0.92rem",
            borderRadius: "8px",
            fontWeight: "600",
            backgroundColor: isDeleting ? "#adb5bd" : "#dc3545",
            border: "none",
            color: "#fff",
            minWidth: "100px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          {isDeleting ? (
            <>
              <Spinner
                animation="border"
                size="sm"
                style={{
                  width: "16px",
                  height: "16px",
                  borderWidth: "2px",
                }}
              />
              <span>Deleting...</span>
            </>
          ) : (
            "Yes, Delete"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const DeleteCommentConfirmModal = ({ isOpen, onClose, onConfirm, isDeleting }) => {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      backdrop="static"
      size="md"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <Modal.Body style={{ padding: "20px" }}>
        {/* Title */}
        <h5
          style={{
            fontWeight: "500",
            color: "#1a1a1a",

            fontSize: "19px",
          }}
        >
          Are you Sure You Want to Delete this Comment?
        </h5>

        {/* Subtitle / Warning */}
        <p
          style={{
            color: "#6c757d",

            fontSize: "14px",
            marginBottom: "-10px",
            lineHeight: "1.5",
          }}
        >
          Once you delete this comment, it can't be restored.
        </p>
      </Modal.Body>

      <Modal.Footer
        style={{
          borderTop: "none",

          display: "flex",

          gap: "12px",
        }}
      >
        {/* Cancel Button */}
        <Button
          onClick={onClose}
          style={{
            padding: "10px 28px",
            fontSize: "0.92rem",
            minWidth: "100px",
            borderRadius: "8px",
            fontWeight: "600",
            backgroundColor: "transparent",
            border: "1px solid #d1d5db",
            color: "#374151",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f3f4f6")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        >
          Cancel
        </Button>

        {/* Yes, Delete Button */}
        <Button
          onClick={onConfirm}
          disabled={isDeleting}
          style={{
            padding: "10px 20px",
            fontSize: "0.92rem",
            borderRadius: "8px",
            fontWeight: "600",
            backgroundColor: isDeleting ? "#adb5bd" : "#dc3545",
            border: "none",
            color: "#fff",
            minWidth: "100px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          {isDeleting ? (
            <>
              <Spinner
                animation="border"
                size="sm"
                style={{
                  width: "16px",
                  height: "16px",
                  borderWidth: "2px",
                }}
              />
              <span>Deleting...</span>
            </>
          ) : (
            "Yes, Delete"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

// Course Community Shimmer Component
const CommunityShimmer = () => (
  <div>
    {[1, 2, 3, 4, 5, 6].map((item) => (
      <Card
        key={item}
        className="mb-3"
        style={{
          borderRadius: "20px",
          backgroundColor: "white",
          border: "1px solid #e9ecef",
        }}
      >
        <Card.Body className="p-4">
          {/* Category and time badges */}
          <div className="d-flex gap-3 mb-3">
            <div
              className="shimmer-box"
              style={{
                width: "150px",
                height: "24px",
                borderRadius: "4px",
              }}
            />
            <div
              className="shimmer-box"
              style={{
                width: "150px",
                height: "24px",
                borderRadius: "4px",
              }}
            />
          </div>

          {/* Title */}
          <div
            className="shimmer-box mb-3"
            style={{
              width: "80%",
              height: "24px",
              borderRadius: "4px",
            }}
          />

          {/* Description */}
          <div
            className="shimmer-box mb-4"
            style={{
              width: "100%",
              height: "60px",
              borderRadius: "4px",
            }}
          />

          {/* Author section */}
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-3">
              <div
                className="shimmer-box rounded-circle"
                style={{
                  width: "48px",
                  height: "48px",
                }}
              />
              <div>
                <div
                  className="shimmer-box mb-2"
                  style={{
                    width: "150px",
                    height: "16px",
                    borderRadius: "4px",
                  }}
                />
                <div
                  className="shimmer-box"
                  style={{
                    width: "120px",
                    height: "14px",
                    borderRadius: "4px",
                  }}
                />
              </div>
            </div>

            {/* Replies */}
            <div className="d-flex gap-3">
              <div
                className="shimmer-box"
                style={{
                  width: "50px",
                  height: "16px",
                  borderRadius: "4px",
                }}
              />
              <div
                className="shimmer-box"
                style={{
                  width: "50px",
                  height: "16px",
                  borderRadius: "4px",
                }}
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    ))}
  </div>
);

// Ask Question Modal Component
const AskQuestionModal = ({
  isOpen,
  onClose,
  questionTitle,
  setQuestionTitle,
  questionDescription,
  setQuestionDescription,
  onSubmit,
  submitting,
  lang,
}) => {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      backdrop="static"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <Modal.Header
        style={{
          borderBottom: "1px solid #e9ecef",
          padding: "20px 24px",
        }}
      >
        <Modal.Title
          style={{
            fontSize: "1.5rem",
            fontWeight: "700",
            color: "#1a1a1a",
            width: "100%",
            textAlign: "center",
          }}
        >
          {lang.ask_question_modal_title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: "24px" }}>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label
              style={{
                fontSize: "0.95rem",
                fontWeight: "600",
                color: "#1a1a1a",
                marginBottom: "8px",
              }}
            >
              {lang.question_title}
            </Form.Label>
            <Form.Control
              type="text"
              placeholder={lang.enter_question_title}
              value={questionTitle}
              onChange={(e) => setQuestionTitle(e.target.value)}
              style={{
                padding: "12px",
                fontSize: "0.95rem",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
              }}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label
              style={{
                fontSize: "0.95rem",
                fontWeight: "600",
                color: "#1a1a1a",
                marginBottom: "8px",
              }}
            >
              {lang.question_description}
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={6}
              placeholder={lang.describe_question_detail}
              value={questionDescription}
              onChange={(e) => setQuestionDescription(e.target.value)}
              maxLength={1000}
              style={{
                padding: "12px",
                fontSize: "0.95rem",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                resize: "vertical",
              }}
            />
            <Form.Text className="text-muted" style={{ fontSize: "0.85rem" }}>
              {questionDescription.length}/1000 {lang.characters}
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer
        style={{
          borderTop: "1px solid #e9ecef",
          padding: "16px 24px",
        }}
      >
        <Button
          onClick={onClose}
          style={{
            padding: "10px 24px",
            fontSize: "0.95rem",
            borderRadius: "8px",
            fontWeight: "600",
            backgroundColor: "transparent",
            border: "1px solid #d1d5db",
            color: "black",
          }}
        >
          {lang.cancell}
        </Button>
        <Button
          onClick={onSubmit}
          disabled={submitting}
          style={{
            backgroundColor: submitting ? "#ccc" : "#00bcd4",
            border: "none",
            padding: "10px 24px",
            fontSize: "0.95rem",
            borderRadius: "8px",
            fontWeight: "600",
          }}
        >
          {submitting ? lang.submitting : lang.submit_question}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default function CourseCommunityList() {
  const navigate = useNavigate();
  const location = useLocation();
  const { courseId } = useParams();
  const { lang } = useContext(Language);
  const [discussions, setDiscussions] = useState([]);
  const [communityLoader, setCommunityLoader] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);

  const user = JSON.parse(localStorage.getItem("SplashData") || "{}");
  const user_id = user?.user?.id;

  const navigatedForumId = location.state?.forumId;
  const course_id = sessionStorage.getItem("CourseId") || "606"; 

  // Purchase related states
  const [isPurchased, setIsPurchased] = useState(false);
  const [purchaseModal, setPurchaseModal] = useState(false);
  const [courseData, setCourseData] = useState(null);

  const [openReplyId, setOpenReplyId] = useState(null);
  const [loadingComments, setLoadingComments] = useState({});
  const [commentsData, setCommentsData] = useState({});

  const [selectedImages, setSelectedImages] = useState({});
  const [showImageModal, setShowImageModal] = useState(false);
  const [modalImageUrl, setModalImageUrl] = useState(null);

  const [replyingTo, setReplyingTo] = useState({});
  const [commentText, setCommentText] = useState({});
  const [postingComment, setPostingComment] = useState({});
  const [imageLoading, setImageLoading] = useState({});

  const [askQuestionModal, setAskQuestionModal] = useState(false);
  const [questionTitle, setQuestionTitle] = useState("");
  const [questionDescription, setQuestionDescription] = useState("");
  const [submittingQuestion, setSubmittingQuestion] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // Delete modal states
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [postToDelete, setPostToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  
  // Comment delete modal states
  const [commentDeleteModalOpen, setCommentDeleteModalOpen] = useState(false);
  const [commentToDelete, setCommentToDelete] = useState(null);
  const [isDeletingComment, setIsDeletingComment] = useState(false);

  const hasAutoOpened = useRef(false);

  const formatDate = (dateString) => {
    if (!dateString) return lang.just_noww;

    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) {
      return lang.just_noww;
    }

    if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes} ${minutes === 1 ? lang.minutee : lang.minutess} ${lang.agoo}`;
    }

    if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return `${hours} ${hours === 1 ? lang.hourr : lang.hourss} ${lang.agoo}`;
    }

    if (diffInSeconds < 604800) {
      const days = Math.floor(diffInSeconds / 86400);
      return `${days} ${days === 1 ? lang.dayy : lang.dayss} ${lang.agoo}`;
    }

    if (diffInSeconds < 2592000) {
      const weeks = Math.floor(diffInSeconds / 604800);
      return `${weeks} ${weeks === 1 ? lang.week : lang.weeks} ${lang.agoo}`;
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  // Fetch course community data from API
  const fetchCourseCommunity = (pageNum = 1, append = false) => {
    if (pageNum === 1) {
      setCommunityLoader(true);
    } else {
      setLoadingMore(true);
    }

    axios
      .get(`${adminBaseURL}user/forum/list`, authorize())
      .then((res) => {
        const discussionsData = res.data.data || [];

        const transformedDiscussions = discussionsData.map((discussion) => ({
          ...discussion,
          user: {
            ...discussion.user,
            role: discussion.user.subcategory
              ? discussion.user.subcategory.split(",")[0].trim()
              : "Medical Professional",
          },
        }));

        if (append) {
          setDiscussions((prev) => [...prev, ...transformedDiscussions]);
        } else {
          setDiscussions(transformedDiscussions);
        }

        if (transformedDiscussions.length < 10) {
          setHasMore(false);
        }

        setCommunityLoader(false);
        setLoadingMore(false);
      })
      .catch((error) => {
        console.log("Error fetching course community:", error);
        toast.error(
          lang.failed_to_load_discussions || "Failed to load discussions",
          {
            position: "top-right",
            autoClose: 3000,
          },
        );
        setCommunityLoader(false);
        setLoadingMore(false);
      });
  };

  const filteredDiscussions = discussions.filter((discussion) => {
    const query = searchQuery.toLowerCase().trim();
    if (!query) return true;

    const titleMatch = discussion.title?.toLowerCase().includes(query);
    const descriptionMatch = discussion.description
      ?.toLowerCase()
      .includes(query);

    return titleMatch || descriptionMatch;
  });

  const fetchComments = async (discussionId) => {
    setLoadingComments((prev) => ({ ...prev, [discussionId]: true }));

    try {
      const response = await axios.get(
        `${adminBaseURL}user/forum/comments/web/${discussionId}`,
        authorize(),
      );

      if (response.data.status) {
        const commentsArray = response.data.data?.data || [];

        const convertedComments = commentsArray.map((comment) => ({
          id: comment.id,
          author: comment.user?.name || lang.anonymous,
          time: formatDate(comment.created_at),
          text: comment.comment,
          likes: comment.likes_count || 0,
          dislikes: comment.dislikes_count || 0,
          image: comment.image ? `${_imagesURL}${comment.image}` : null,
          userImage: comment.user?.image
            ? `${_imagesURL}${comment.user.image}`
            : null,
          isLike: comment.isLike || false,
          userId: comment.user?.id,
          nestedReplies: comment.replies
            ? comment.replies.map((reply) => ({
                id: reply.id,
                author: reply.user?.name || lang.anonymous,
                time: formatDate(reply.created_at),
                text: reply.comment,
                likes: reply.likes_count || 0,
                dislikes: reply.dislikes_count || 0,
                image: reply.image ? `${_imagesURL}${reply.image}` : null,
                userImage: reply.user?.image
                  ? `${_imagesURL}${reply.user.image}`
                  : null,
                isLike: reply.isLike || false,
                userId: reply.user?.id,
              }))
            : [],
        }));

        setDiscussions((prevDiscussions) =>
          prevDiscussions.map((d) =>
            d.id === discussionId
              ? {
                  ...d,
                  replyList: convertedComments,
                  replies:
                    response.data.data?.total || convertedComments.length,
                }
              : d,
          ),
        );

        setCommentsData((prev) => ({
          ...prev,
          [discussionId]: convertedComments,
        }));
      }

      setLoadingComments((prev) => ({ ...prev, [discussionId]: false }));
    } catch (error) {
      console.error("Error fetching comments:", error);
      setLoadingComments((prev) => ({ ...prev, [discussionId]: false }));
      toast.error(lang.failed_to_load_comments, {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  // Fetch course purchase status
  const fetchCoursePurchaseStatus = () => {
    axios
      .get(`${adminBaseURL}user/web/course/detail/${course_id}`, authorize())
      .then((res) => {
        const data = res.data.data;
        setCourseData(data);
        
        if (user_id === data?.user?.id || data.isPurchase) {
          setIsPurchased(true);
        } else {
          setIsPurchased(false);
        }
      })
      .catch((error) => {
        console.log("Error fetching course status:", error);
      });
  };

  useEffect(() => {
    fetchCourseCommunity(1);
    fetchCoursePurchaseStatus();
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, 0);
  }, [course_id]);

  useEffect(() => {
    if (
      navigatedForumId &&
      discussions.length > 0 &&
      !communityLoader &&
      !hasAutoOpened.current
    ) {
      const forumExists = discussions.some((d) => d.id === navigatedForumId);

      if (forumExists) {
        hasAutoOpened.current = true;

        setOpenReplyId(navigatedForumId);

        fetchComments(navigatedForumId);

        setTimeout(() => {
          const element = document.getElementById(`forum-${navigatedForumId}`);
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 300);
      }
    }
  }, [navigatedForumId, communityLoader]);

  const toggleReplies = (id) => {
    const isCurrentlyOpen = openReplyId === id;

    if (!isCurrentlyOpen) {
      setOpenReplyId(id);
      fetchComments(id);
    } else {
      setOpenReplyId(null);
    }
  };

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchCourseCommunity(nextPage, true);
  };

  const handleAskQuestion = () => {
    if (!isPurchased) {
      setPurchaseModal(true);
      return;
    }
    setAskQuestionModal(true);
  };

  const handleCloseAskQuestion = () => {
    setAskQuestionModal(false);
    setQuestionTitle("");
    setQuestionDescription("");
  };

  const handleSubmitQuestion = () => {
    if (!questionTitle.trim()) {
      toast.error(lang.please_enter_question_title, {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    if (!questionDescription.trim()) {
      toast.error(lang.please_enter_question_description, {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    setSubmittingQuestion(true);

    axios
      .post(
        `${adminBaseURL}user/forum/create`,
        {
          title: questionTitle,
          description: questionDescription,
        },
        authorize(),
      )
      .then((res) => {
        toast.success(lang.question_submitted_success, {
          position: "top-right",
          autoClose: 3000,
        });
        handleCloseAskQuestion();
        fetchCourseCommunity(1);
      })
      .catch((error) => {
        console.log("Error submitting question:", error);
        toast.error(lang.failed_submit_question, {
          position: "top-right",
          autoClose: 3000,
        });
      })
      .finally(() => {
        setSubmittingQuestion(false);
      });
  };

  // Handle delete flow
  const handleOpenDeleteModal = (discussion) => {
    setPostToDelete(discussion);
    setDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
    setPostToDelete(null);
    setIsDeleting(false);
  };

  const handleConfirmDelete = () => {
    if (!postToDelete) return;
    setIsDeleting(true);

    axios
      .get(
        `${adminBaseURL}user/forum/delete/${postToDelete.id}`,
        authorize(),
      )
      .then((res) => {
        toast.success("Forum deleted", {
          position: "top-right",
          autoClose: 3000,
        });
        handleCloseDeleteModal();
        fetchCourseCommunity(1); // Refresh list
      })
      .catch((error) => {
        console.log("Error deleting post:", error);
        toast.error("Failed to delete post. Please try again.", {
          position: "top-right",
          autoClose: 3000,
        });
        setIsDeleting(false);
        handleCloseDeleteModal();
      });
  };

  // Handle comment delete flow
  const handleOpenCommentDeleteModal = (comment, discussionId) => {
    setCommentToDelete({ comment, discussionId });
    setCommentDeleteModalOpen(true);
  };

  const handleCloseCommentDeleteModal = () => {
    setCommentDeleteModalOpen(false);
    setCommentToDelete(null);
    setIsDeletingComment(false);
  };

  const handleConfirmCommentDelete = () => {
    if (!commentToDelete) return;
    setIsDeletingComment(true);

    axios
      .get(
        `${adminBaseURL}user/forum/comments/delete/${commentToDelete.comment.id}`,
        authorize(),
      )
      .then((res) => {
        toast.success("Comment deleted", {
          position: "top-right",
          autoClose: 3000,
        });
        handleCloseCommentDeleteModal();
        fetchComments(commentToDelete.discussionId); // Refresh comments
      })
      .catch((error) => {
        console.log("Error deleting comment:", error);
        toast.error("Failed to delete comment. Please try again.", {
          position: "top-right",
          autoClose: 3000,
        });
        setIsDeletingComment(false);
        handleCloseCommentDeleteModal();  
      });
  };

  const handleImageSelect = (event, key) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImages((prev) => ({
          ...prev,
          [key]: {
            file: file,
            previewUrl: reader.result,
          },
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = (e, key) => {
    e.stopPropagation();
    setSelectedImages((prev) => {
      const newState = { ...prev };
      delete newState[key];
      return newState;
    });
  };

  const handleInputImageClick = (e, imageUrl) => {
    e.stopPropagation();
    if (imageUrl) {
      setModalImageUrl(imageUrl);
      setShowImageModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowImageModal(false);
    setModalImageUrl(null);
  };

  const toggleReplyInput = (discussionId, replyId) => {
    const key = `${discussionId}-${replyId}`;
    setReplyingTo((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleImageLoad = (imageKey) => {
    setImageLoading((prev) => ({ ...prev, [imageKey]: false }));
  };

  const handleImageLoadStart = (imageKey) => {
    setImageLoading((prev) => ({ ...prev, [imageKey]: true }));
  };

  const handlePostComment = async (discussionId, parentId = null) => {
    if (!isPurchased) {
      setPurchaseModal(true);
      return;
    }

    const key = parentId ? `${discussionId}-${parentId}` : discussionId;
    const text = commentText[key];
    const image = selectedImages[key];

    if (!text || text.trim() === "") {
      toast.error(lang.please_enter_a_comment, {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    setPostingComment((prev) => ({ ...prev, [key]: true }));

    try {
      const formData = new FormData();
      formData.append("forum_id", discussionId);
      formData.append("comment", text.trim());

      if (parentId) {
        formData.append("parent", parentId);
      }

      if (image && image.file) {
        formData.append("image", image.file);
      }

      const response = await axios.post(
        `${adminBaseURL}user/forum/comments/create`,
        formData,
        {
          ...authorize(),
          headers: {
            ...authorize().headers,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.data.status) {
        setCommentText((prev) => ({ ...prev, [key]: "" }));
        setSelectedImages((prev) => {
          const newState = { ...prev };
          delete newState[key];
          return newState;
        });

        if (parentId) {
          setReplyingTo((prev) => ({ ...prev, [key]: false }));
        }

        fetchComments(discussionId);
      }

      setPostingComment((prev) => ({ ...prev, [key]: false }));
    } catch (error) {
      console.error("Error posting comment:", error);
      toast.error(lang.failed_to_post_comment, {
        position: "top-right",
        autoClose: 3000,
      });
      setPostingComment((prev) => ({ ...prev, [key]: false }));
    }
  };

  const handleLikeComment = async (commentId, discussionId) => {
    try {
      setDiscussions((prevDiscussions) =>
        prevDiscussions.map((d) => {
          if (d.id === discussionId) {
            const updateReply = (reply) => {
              if (reply.id === commentId) {
                const wasLiked = reply.isLike;
                const wasDisliked = reply.dislikes > 0;
                if (wasLiked) {
                  return {
                    ...reply,
                    likes: reply.likes - 1,
                    isLike: false,
                  };
                } else {
                  return {
                    ...reply,
                    likes: reply.likes + 1,
                    dislikes: wasDisliked ? reply.dislikes - 1 : reply.dislikes,
                    isLike: true,
                  };
                }
              }

              if (reply.nestedReplies && reply.nestedReplies.length > 0) {
                return {
                  ...reply,
                  nestedReplies: reply.nestedReplies.map((nested) =>
                    nested.id === commentId
                      ? (() => {
                          const wasLiked = nested.isLike;
                          const wasDisliked = nested.dislikes > 0;
                          if (wasLiked) {
                            return {
                              ...nested,
                              likes: nested.likes - 1,
                              isLike: false,
                            };
                          } else {
                            return {
                              ...nested,
                              likes: nested.likes + 1,
                              dislikes: wasDisliked
                                ? nested.dislikes - 1
                                : nested.dislikes,
                              isLike: true,
                            };
                          }
                        })()
                      : nested,
                  ),
                };
              }

              return reply;
            };

            return {
              ...d,
              replyList: d.replyList ? d.replyList.map(updateReply) : [],
            };
          }
          return d;
        }),
      );

      const response = await axios.get(
        `${adminBaseURL}user/forum/comments/like/${commentId}/1`,
        authorize(),
      );

      if (!response.data.status) {
        fetchComments(discussionId);
      }
    } catch (error) {
      console.error("Error liking comment:", error);
      fetchComments(discussionId);
    }
  };

  const handleDislikeComment = async (commentId, discussionId) => {
    try {
      setDiscussions((prevDiscussions) =>
        prevDiscussions.map((d) => {
          if (d.id === discussionId) {
            const updateReply = (reply) => {
              if (reply.id === commentId) {
                const wasDisliked = reply.dislikes > 0;
                const wasLiked = reply.isLike;
                if (wasDisliked) {
                  return {
                    ...reply,
                    dislikes: reply.dislikes - 1,
                  };
                } else {
                  return {
                    ...reply,
                    dislikes: reply.dislikes + 1,
                    likes: wasLiked ? reply.likes - 1 : reply.likes,
                    isLike: false,
                  };
                }
              }

              if (reply.nestedReplies && reply.nestedReplies.length > 0) {
                return {
                  ...reply,
                  nestedReplies: reply.nestedReplies.map((nested) =>
                    nested.id === commentId
                      ? (() => {
                          const wasDisliked = nested.dislikes > 0;
                          const wasLiked = nested.isLike;
                          if (wasDisliked) {
                            return {
                              ...nested,
                              dislikes: nested.dislikes - 1,
                            };
                          } else {
                            return {
                              ...nested,
                              dislikes: nested.dislikes + 1,
                              likes: wasLiked ? nested.likes - 1 : nested.likes,
                              isLike: false,
                            };
                          }
                        })()
                      : nested,
                  ),
                };
              }

              return reply;
            };

            return {
              ...d,
              replyList: d.replyList ? d.replyList.map(updateReply) : [],
            };
          }
          return d;
        }),
      );

      const response = await axios.get(
        `${adminBaseURL}user/forum/comments/like/${commentId}/0`,
        authorize(),
      );

      if (!response.data.status) {
        fetchComments(discussionId);
      }
    } catch (error) {
      console.error("Error disliking comment:", error);
      fetchComments(discussionId);
    }
  };

  const renderNestedReply = (nestedReply, discussionId, parentReplyId, postOwnerId) => {
    const nestedKey = `nested-${discussionId}-${parentReplyId}-${nestedReply.id}`;
    const imageKey = `img-${nestedKey}`;
    const canDeleteComment = user_id === postOwnerId || user_id === nestedReply.userId;

    return (
      <div
        key={nestedReply.id}
        className="mb-3"
        style={{ marginLeft: "82px", borderLeft: "1px solid #B2ECF5" }}
      >
        <div className="d-flex gap-3" style={{ marginLeft: "10px" }}>
          <UserImageWithLoader
            src={nestedReply.userImage || place}
            alt={nestedReply.author}
            fallbackSrc={place}
            size="32px"
          />
          <div style={{ flex: 1 }}>
            <div className="d-flex align-items-center justify-content-between mb-1">
              <span
                className="fw-bold"
                style={{
                  fontSize: "13px",
                  color: "#1a1a1a",
                }}
              >
                {nestedReply.author}
              </span>
              <ThreeDotsMenu
                onDelete={() => handleOpenCommentDeleteModal(nestedReply, discussionId)}
                show={canDeleteComment}
              />
            </div>
            <div
              style={{
                fontSize: "11px",
                color: "#9e9e9e",
                marginBottom: "8px",
              }}
            >
              {lang.postedd} {nestedReply.time}
            </div>
          </div>
        </div>

        <div style={{ borderBottom: "1px solid #E6F9FC", marginLeft: "10px" }}>
          {nestedReply.image && (
            <div style={{ position: "relative", display: "inline-block" }}>
              {imageLoading[imageKey] && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    maxWidth: "200px",
                    height: "150px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "8px",
                  }}
                >
                  <Spinner animation="border" style={{ color: "#000" }} />
                </div>
              )}
              <img
                src={nestedReply.image}
                onError={(e) => {
                  e.target.src = comment;
                  setImageLoading((prev) => ({ ...prev, [imageKey]: false }));
                }}
                onLoadStart={() => handleImageLoadStart(imageKey)}
                onLoad={() => handleImageLoad(imageKey)}
                alt={lang.comment_attachment}
                style={{
                  width: "100%",
                  maxWidth: "200px",
                  height: "auto",
                  borderRadius: "8px",
                  marginBottom: "8px",
                  objectFit: "cover",
                  display: imageLoading[imageKey] ? "none" : "block",
                }}
              />
            </div>
          )}
          <p
            style={{
              fontSize: "13px",
              color: "black",
              lineHeight: "1.6",
              marginBottom: "10px",
            }}
          >
            {nestedReply.text}
          </p>
          <div
            className="d-flex align-items-center gap-3"
            style={{ paddingBottom: "10px" }}
          >
            <span
              className="d-flex align-items-center gap-1"
              onClick={() => handleLikeComment(nestedReply.id, discussionId)}
              style={{
                fontSize: "12px",
                color: nestedReply.isLike ? "#00bcd4" : "#6c757d",
                cursor: "pointer",
              }}
            >
              <AiOutlineLike size={14} />
              {nestedReply.likes} {lang.likess}
            </span>
            <span
              className="d-flex align-items-center gap-1"
              onClick={() => handleDislikeComment(nestedReply.id, discussionId)}
              style={{
                fontSize: "12px",
                color: nestedReply.dislikes > 0 ? "#00bcd4" : "#6c757d",
                cursor: "pointer",
              }}
            >
              <AiOutlineDislike size={14} style={{ marginTop: "3px" }} />
              {nestedReply.dislikes} {lang.dislikes}
            </span>
          </div>
        </div>
      </div>
    );
  };

  // Render main reply with nested replies
  const renderReply = (reply, discussionId, postOwnerId) => {
    const replyKey = `${discussionId}-${reply.id}`;
    const isReplyingToThis = replyingTo[replyKey];
    const imageKey = `img-reply-${replyKey}`;
    const canDeleteComment = user_id === postOwnerId || user_id === reply.userId;

    return (
      <div key={reply.id} className="mb-4">
        <div className="d-flex gap-3">
          <UserImageWithLoader
            src={reply.userImage || place}
            alt={reply.author}
            fallbackSrc={place}
            size="40px"
          />
          <div style={{ flex: 1 }}>
            <div className="d-flex align-items-center justify-content-between mb-1">
              <span
                className="fw-bold"
                style={{
                  fontSize: "14px",
                  color: "#1a1a1a",
                }}
              >
                {reply.author}
              </span>
              <ThreeDotsMenu
                onDelete={() => handleOpenCommentDeleteModal(reply, discussionId)}
                show={canDeleteComment}
              />
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#9e9e9e",
                marginBottom: "8px",
              }}
            >
              {lang.postedd} {reply.time}
            </div>
          </div>
        </div>

        <div>
          {reply.image && (
            <div style={{ position: "relative", display: "inline-block" }}>
              {imageLoading[imageKey] && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    maxWidth: "200px",
                    height: "150px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "8px",
                  }}
                >
                  <Spinner animation="border" style={{ color: "#000" }} />
                </div>
              )}
              <img
                src={reply.image}
                onError={(e) => {
                  e.target.src = comment1;
                  setImageLoading((prev) => ({ ...prev, [imageKey]: false }));
                }}
                onLoadStart={() => handleImageLoadStart(imageKey)}
                onLoad={() => handleImageLoad(imageKey)}
                alt={lang.comment_attachment}
                style={{
                  width: "100%",
                  maxWidth: "200px",
                  height: "auto",
                  borderRadius: "8px",
                  marginBottom: "8px",
                  objectFit: "cover",
                  display: imageLoading[imageKey] ? "none" : "block",
                }}
              />
            </div>
          )}
          <p
            style={{
              fontSize: "14px",
              color: "black",
              lineHeight: "1.6",
              marginBottom: "12px",
            }}
          >
            {reply.text}
          </p>
          <div
            className="d-flex align-items-center gap-3"
            style={{ borderBottom: "1px solid #E6F9FC", paddingBottom: "10px" }}
          >
            <span
              className="d-flex align-items-center gap-1"
              onClick={() => handleLikeComment(reply.id, discussionId)}
              style={{
                fontSize: "13px",
                color: reply.isLike ? "#00bcd4" : "#6c757d",
                cursor: "pointer",
              }}
            >
              <AiOutlineLike size={16} />
              {reply.likes} {lang.likess}
            </span>
            <span
              className="d-flex align-items-center gap-1"
              onClick={() => handleDislikeComment(reply.id, discussionId)}
              style={{
                fontSize: "13px",
                color: reply.dislikes > 0 ? "#00bcd4" : "#6c757d",
                cursor: "pointer",
              }}
            >
              <AiOutlineDislike size={16} style={{ marginTop: "3px" }} />
              {reply.dislikes} {lang.dislikes}
            </span>
            <span
              className="d-flex align-items-center gap-1"
              style={{
                fontSize: "13px",
                color: "#6c757d",
                cursor: "pointer",
              }}
              onClick={() => toggleReplyInput(discussionId, reply.id)}
            >
              <BiReply size={16} />
              {lang.replyy}
            </span>
          </div>

          {/* Nested Replies */}
          {reply.nestedReplies && reply.nestedReplies.length > 0 && (
            <div className="mt-3">
              {reply.nestedReplies.map((nestedReply) =>
                renderNestedReply(nestedReply, discussionId, reply.id, postOwnerId),
              )}
            </div>
          )}

          {/* Reply Input for this comment */}
          {isReplyingToThis && (
            <div className="mt-3" style={{ marginLeft: "52px" }}>
              <div
                className="d-flex align-items-center gap-2"
                style={{
                  backgroundColor: "white",
                  borderRadius: "12px",
                  border: "1px solid #d8d9da",
                  padding: "8px 16px 8px 8px",
                }}
              >
                <UserImageWithLoader
                  src={place}
                  alt="User"
                  fallbackSrc={place}
                  size="32px"
                />
                <Form.Control
                  type="text"
                  placeholder={lang.write_a_comment}
                  value={commentText[replyKey] || ""}
                  onChange={(e) =>
                    setCommentText((prev) => ({
                      ...prev,
                      [replyKey]: e.target.value,
                    }))
                  }
                  onKeyPress={(e) => {
                    if (e.key === "Enter" && !postingComment[replyKey]) {
                      e.preventDefault();
                      handlePostComment(discussionId, reply.id);
                    }
                  }}
                  style={{
                    border: "none",
                    backgroundColor: "transparent",
                    fontSize: "13px",
                    color: "black",
                    boxShadow: "none",
                    outline: "none",
                    padding: "0",
                  }}
                  onFocus={(e) => {
                    e.target.style.outline = "none";
                    e.target.style.boxShadow = "none";
                  }}
                />
                <div style={{ position: "relative" }}>
                  {!selectedImages[replyKey] ? (
                    <>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageSelect(e, replyKey)}
                        style={{ display: "none" }}
                        id={`file-input-${replyKey}`}
                      />
                      <label
                        htmlFor={`file-input-${replyKey}`}
                        style={{
                          cursor: "pointer",
                          margin: 0,
                          display: "flex",
                        }}
                      >
                        <img
                          src={photo}
                          alt={lang.add_photo}
                          style={{
                            width: "24px",
                            height: "24px",
                            filter: "brightness(0) invert(1)",
                          }}
                        />
                      </label>
                    </>
                  ) : (
                    <div
                      style={{
                        position: "relative",
                        width: "40px",
                        height: "40px",
                      }}
                    >
                      <img
                        src={selectedImages[replyKey].previewUrl}
                        alt={lang.selected}
                        onClick={(e) =>
                          handleInputImageClick(
                            e,
                            selectedImages[replyKey].previewUrl,
                          )
                        }
                        style={{
                          width: "40px",
                          height: "40px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          cursor: "pointer",
                        }}
                      />
                      <button
                        onClick={(e) => handleRemoveImage(e, replyKey)}
                        style={{
                          position: "absolute",
                          top: "2px",
                          right: "2px",
                          backgroundColor: "white",
                          border: "none",
                          borderRadius: "3px",
                          width: "14px",
                          height: "14px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          padding: 0,
                        }}
                      >
                        <IoClose size={12} color="black" />
                      </button>
                    </div>
                  )}
                </div>
                <Button
                  onClick={() => handlePostComment(discussionId, reply.id)}
                  disabled={postingComment[replyKey]}
                  style={{
                    backgroundColor: "black",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    padding: "8px 16px",
                    fontSize: "13px",
                    fontWeight: "500",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  {postingComment[replyKey] ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    lang.postt
                  )}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const isEmptyState =
    !communityLoader &&
    (discussions.length === 0 ||
      (filteredDiscussions.length === 0 && searchQuery.trim() !== ""));

  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <NavBar />

        <div
          className="community-section"
          style={{
            backgroundColor: "#f8fbff",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            paddingTop: "clamp(80px, 80vw, 80px)",
            paddingBottom: "clamp(32px, 6vw, 80px)",
          }}
        >
          <div
            className="responsive-container"
            style={{
              maxWidth: "1100px",
              flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header Section */}
            <div className="mb-4">
              <h1 className="fw-bold mb-2" style={{ fontSize: "30px" }}>
                {lang.course_community}
              </h1>
              <p className="text-muted">
                {lang.course_community_join_dialogue}
              </p>
            </div>

            {/* Action Bar */}
            <Row className=" g-3" style={{ marginBottom: "30px" }}>
              <Col xs={12} md="auto">
                <div className="d-flex justify-content-center">
                  <Button
                    onClick={handleAskQuestion}
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      backgroundColor: "#00bcd4",
                      color: "white",
                      border: "none",
                      borderRadius: "12px",
                      padding: "11px 14px",
                      gap: "6px",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        lineHeight: 1,
                      }}
                    >
                      <BsQuestionCircle size={20} />
                    </span>

                    <span
                      style={{
                        lineHeight: 1,
                        fontSize: "15px",
                        fontWeight: 400,
                      }}
                    >
                      {lang.ask_a_questionn}
                    </span>
                  </Button>
                </div>
              </Col>

              <Col xs={12} md={5} lg={3}>
                <div
                  style={{
                    position: "relative",
                    borderRadius: "12px",
                    border: "1px solid #e8e8e8",
                    backgroundColor: "white",
                    overflow: "hidden",
                  }}
                >
                  <CiSearch
                    size={20}
                    style={{
                      position: "absolute",
                      left: "16px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "black",
                      zIndex: 1,
                    }}
                  />
                  <Form.Control
                    type="text"
                    placeholder={lang.search_in_community_discussion}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{
                      border: "none",
                      boxShadow: "none",
                      fontSize: "14px",
                      color: "black",
                      paddingLeft: "45px",
                      paddingRight: "16px",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      backgroundColor: "transparent",
                      outline: "none",
                    }}
                    onFocus={(e) => {
                      e.target.style.outline = "none";
                    }}
                  />
                </div>
              </Col>
            </Row>

            {/* ── CONTENT AREA ── flex:1 so it fills leftover height */}
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",

                justifyContent: isEmptyState ? "center" : "flex-start",
              }}
            >
              {communityLoader ? (
                <CommunityShimmer />
              ) : discussions.length === 0 ? (
                /* ── NO POSTS AT ALL ── */
                <div
                  className="text-center"
                  style={{
                    padding: "40px 20px",
                  }}
                >
                  <p
                    className="mb-0 responsive-text"
                    style={{
                      color: "black",
                      fontWeight: "500",
                      fontSize: "1.1rem",
                    }}
                  >
                    {lang.no_post_added_yet}
                  </p>
                </div>
              ) : filteredDiscussions.length === 0 &&
                searchQuery.trim() !== "" ? (
                /* ── NO SEARCH RESULTS ── */
                <div
                  className="text-center"
                  style={{
                    padding: "40px 20px",
                  }}
                >
                  <p
                    className="mb-0 responsive-text"
                    style={{
                      color: "black",
                      fontWeight: "500",
                      fontSize: "1.1rem",
                    }}
                  >
                    {lang.no_posts_found_for_keyword}
                  </p>
                </div>
              ) : (
                <>
                  {filteredDiscussions.map((d) => (
                    <Card
                      key={d.id}
                      id={`forum-${d.id}`}
                      className="mb-3"
                      style={{
                        borderRadius: "20px",
                        backgroundColor: "white",
                        border: "1px solid #d8d9da",
                        overflow: "hidden",
                      }}
                    >
                      <Card.Body className="p-4">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
                          <div className="d-flex flex-wrap align-items-center gap-3">
                            <span
                              className="text-xs fw-semibold text-uppercase responsive-small-text"
                              style={{
                                color: "#00bcd4",
                                backgroundColor: "#E6F9FC",
                                padding: "4px 8px",
                                borderRadius: "4px",
                                letterSpacing: "0.5px",
                              }}
                            >
                              {d.user.category} -{" "}
                              {d.user.subcategory
                                ? d.user.subcategory.split(",")[0].trim()
                                : d.user.subcategory}
                            </span>
                            <span
                              className="text-uppercase responsive-small-text"
                              style={{ color: "black", fontWeight: "500" }}
                            >
                              {lang.posted.toUpperCase()}{" "}
                              {formatDate(d.created_at)}
                            </span>
                          </div>
                          {user_id === d.user.id && (
                            <ThreeDotsMenu
                              onDelete={() => handleOpenDeleteModal(d)}
                            />
                          )}
                        </div>

                        <h3
                          className="mb-3 responsive-subsection-title"
                          style={{ fontWeight: "bold", color: "#1a1a1a" }}
                        >
                          {d.title}
                        </h3>

                        <p
                          className="mb-4 responsive-text"
                          style={{ color: "#4a5568", lineHeight: "1.6" }}
                        >
                          {d.description}
                        </p>

                        <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3">
                          <div className="d-flex align-items-center">
                            {(() => {
                              let displayName = d.user.name;
                              let displayRole = d.user.role;
                              let displayImage = _imagesURL + d.user.image;
                              if (d.user.id === 259) {
                                displayName = "Dr. A.Martín";
                                displayRole = "Ophthalmologist – Cornea and Ocular Surface Specialist";
                                displayImage = dd1;
                              } else if (d.user.id === 2122) {
                                displayName = "Dr. L.Sánchez";
                                displayRole = "Ophthalmologist – Refractive and Cosmetic Ocular Surgery";
                                displayImage = dd2;
                              }
                              return (
                                <>
                                  <UserImageWithLoader
                                    src={displayImage}
                                    alt={displayName}
                                    fallbackSrc={place}
                                    size="48px"
                                    className="me-3"
                                  />
                                  <div>
                                    <div
                                      className="fw-bold responsive-text"
                                      style={{ color: "#1a1a1a" }}
                                    >
                                      {displayName}
                                    </div>
                                    <div
                                      className="responsive-small-text"
                                      style={{ color: "#6c757d" }}
                                    >
                                      {displayRole}
                                    </div>
                                  </div>
                                </>
                              );
                            })()}
                          </div>

                          <div className="d-flex align-items-center gap-4 flex-wrap">
                            <div
                              onClick={() => toggleReplies(d.id)}
                              className="d-flex align-items-center gap-2 cursor-pointer responsive-small-text"
                              style={{
                                color: "#02c8e2",
                                fontWeight: "700",
                                cursor: "pointer",
                              }}
                            >
                              <LuMessageSquarePlus
                                size={16}
                                style={{ marginTop: "5px" }}
                              />
                              <span>{lang.add_commentt}</span>
                            </div>

                            <span
                              onClick={() => toggleReplies(d.id)}
                              className="d-flex align-items-center gap-2 text-decoration-none responsive-small-text"
                              style={{
                                color: "#02c8e2",
                                fontWeight: "700",
                                cursor: "pointer",
                              }}
                            >
                              {openReplyId === d.id
                                ? lang.hide_replies
                                : lang.view_replies}{" "}
                              {d.comments_count || 0}{" "}
                              {(d.comments_count || 0) === 1
                                ? lang.reply_replies
                                : lang.repliesss}
                              <FaArrowDown
                                size={16}
                                style={{
                                  transform:
                                    openReplyId === d.id
                                      ? "rotate(180deg)"
                                      : "rotate(0deg)",
                                  transition: "transform 0.3s ease",
                                }}
                              />
                            </span>
                          </div>
                        </div>

                        {/* Replies Accordion */}
                        <Collapse in={openReplyId === d.id}>
                          <div
                            style={{
                              marginLeft: "-1.5rem",
                              marginRight: "-1.5rem",
                              marginBottom: "-1.5rem",
                              marginTop: "1.5rem",
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: "rgba(230, 249, 252, 0.3)",
                                padding: "20px 1.5rem",
                                borderTop: "1px solid #d8d9da",
                              }}
                            >
                              <h5
                                style={{
                                  fontSize: "14px",
                                  color: "#1a1a1a",
                                  marginBottom: "30px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                  fontWeight: "bold",
                                }}
                              >
                                {lang.commentss} ({d.comments_count || 0})
                              </h5>

                              {/* Loading spinner for comments */}
                              {loadingComments[d.id] ? (
                                <div className="text-center py-5">
                                  <Spinner
                                    animation="border"
                                    role="status"
                                    style={{ color: "#00bcd4" }}
                                  >
                                    <span className="visually-hidden">
                                      {lang.loading_comments}
                                    </span>
                                  </Spinner>
                                  <p className="mt-3 text-muted">
                                    {lang.loading_comments}
                                  </p>
                                </div>
                              ) : d.replyList && d.replyList.length > 0 ? (
                                <>
                                  {d.replyList.map((reply) =>
                                    renderReply(reply, d.id, d.user.id),
                                  )}

                                  {/* Write a comment section */}
                                  <div className="d-flex gap-3 mt-4">
                                    <div
                                      className="flex-grow-1 d-flex align-items-center gap-2"
                                      style={{
                                        backgroundColor: "white",
                                        borderRadius: "12px",
                                        border: "1px solid #d8d9da",
                                        padding: "8px 16px 8px 8px",
                                      }}
                                    >
                                      <UserImageWithLoader
                                        src={place}
                                        alt="User"
                                        fallbackSrc={place}
                                        size="36px"
                                      />
                                      <Form.Control
                                        type="text"
                                        placeholder={lang.write_a_comment}
                                        value={commentText[d.id] || ""}
                                        onChange={(e) =>
                                          setCommentText((prev) => ({
                                            ...prev,
                                            [d.id]: e.target.value,
                                          }))
                                        }
                                        onKeyPress={(e) => {
                                          if (
                                            e.key === "Enter" &&
                                            !postingComment[d.id]
                                          ) {
                                            e.preventDefault();
                                            handlePostComment(d.id);
                                          }
                                        }}
                                        style={{
                                          border: "none",
                                          backgroundColor: "transparent",
                                          fontSize: "14px",
                                          color: "black",
                                          boxShadow: "none",
                                          outline: "none",
                                          padding: "0",
                                        }}
                                        onFocus={(e) => {
                                          e.target.style.outline = "none";
                                          e.target.style.boxShadow = "none";
                                        }}
                                      />
                                      <div style={{ position: "relative" }}>
                                        {!selectedImages[d.id] ? (
                                          <>
                                            <input
                                              type="file"
                                              accept="image/*"
                                              onChange={(e) =>
                                                handleImageSelect(e, d.id)
                                              }
                                              style={{ display: "none" }}
                                              id={`file-input-${d.id}`}
                                            />
                                            <label
                                              htmlFor={`file-input-${d.id}`}
                                              style={{
                                                cursor: "pointer",
                                                margin: 0,
                                                display: "flex",
                                              }}
                                            >
                                              <img
                                                src={photo}
                                                alt={lang.add_photo}
                                                style={{
                                                  width: "30px",
                                                  height: "30px",
                                                  filter:
                                                    "brightness(0) invert(1)",
                                                }}
                                              />
                                            </label>
                                          </>
                                        ) : (
                                          <div
                                            style={{
                                              position: "relative",
                                              width: "50px",
                                              height: "50px",
                                            }}
                                          >
                                            <img
                                              src={
                                                selectedImages[d.id].previewUrl
                                              }
                                              alt={lang.selected}
                                              onClick={(e) =>
                                                handleInputImageClick(
                                                  e,
                                                  selectedImages[d.id]
                                                    .previewUrl,
                                                )
                                              }
                                              style={{
                                                width: "50px",
                                                height: "50px",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                                cursor: "pointer",
                                              }}
                                            />
                                            <button
                                              onClick={(e) =>
                                                handleRemoveImage(e, d.id)
                                              }
                                              style={{
                                                position: "absolute",
                                                top: "3px",
                                                right: "3px",
                                                backgroundColor: "white",
                                                border: "none",
                                                borderRadius: "3px",
                                                width: "15px",
                                                height: "15px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                                padding: 0,
                                              }}
                                            >
                                              <IoClose
                                                size={16}
                                                color="black"
                                              />
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                      <Button
                                        onClick={() => handlePostComment(d.id)}
                                        disabled={postingComment[d.id]}
                                        style={{
                                          backgroundColor: "black",
                                          color: "white",
                                          border: "none",
                                          borderRadius: "8px",
                                          padding: "6px 16px",
                                          fontSize: "14px",
                                          fontWeight: "500",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                        }}
                                      >
                                        {postingComment[d.id] ? (
                                          <Spinner
                                            animation="border"
                                            size="sm"
                                          />
                                        ) : (
                                          lang.post
                                        )}
                                      </Button>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div
                                    style={{
                                      color: "black",
                                      display: "flex",
                                      flexDirection: "column",
                                      fontWeight: "600",
                                      textAlign: "center",
                                      marginBottom: "20px",
                                    }}
                                  >
                                    {lang.there_are_no_comments_yet}
                                    <span
                                      style={{
                                        color: "gray",
                                        fontWeight: "400",
                                      }}
                                    >
                                      {lang.start_discussion_by_adding_comment}
                                    </span>
                                  </div>

                                  <div className="d-flex gap-3 mt-4">
                                    <div
                                      className="flex-grow-1 d-flex align-items-center gap-2"
                                      style={{
                                        backgroundColor: "white",
                                        borderRadius: "12px",
                                        border: "1px solid #d8d9da",
                                        padding: "8px 16px 8px 8px",
                                      }}
                                    >
                                      <UserImageWithLoader
                                        src={place}
                                        alt="User"
                                        fallbackSrc={place}
                                        size="36px"
                                      />
                                      <Form.Control
                                        type="text"
                                        placeholder={lang.write_a_comment}
                                        value={commentText[d.id] || ""}
                                        onChange={(e) =>
                                          setCommentText((prev) => ({
                                            ...prev,
                                            [d.id]: e.target.value,
                                          }))
                                        }
                                        onKeyPress={(e) => {
                                          if (
                                            e.key === "Enter" &&
                                            !postingComment[d.id]
                                          ) {
                                            e.preventDefault();
                                            handlePostComment(d.id);
                                          }
                                        }}
                                        style={{
                                          border: "none",
                                          backgroundColor: "transparent",
                                          fontSize: "14px",
                                          color: "black",
                                          boxShadow: "none",
                                          outline: "none",
                                          padding: "0",
                                        }}
                                        onFocus={(e) => {
                                          e.target.style.outline = "none";
                                          e.target.style.boxShadow = "none";
                                        }}
                                      />
                                      <div style={{ position: "relative" }}>
                                        {!selectedImages[d.id] ? (
                                          <>
                                            <input
                                              type="file"
                                              accept="image/*"
                                              onChange={(e) =>
                                                handleImageSelect(e, d.id)
                                              }
                                              style={{ display: "none" }}
                                              id={`file-input-nocomments-${d.id}`}
                                            />
                                            <label
                                              htmlFor={`file-input-nocomments-${d.id}`}
                                              style={{
                                                cursor: "pointer",
                                                margin: 0,
                                                display: "flex",
                                              }}
                                            >
                                              <img
                                                src={photo}
                                                alt={lang.add_photo}
                                                style={{
                                                  width: "30px",
                                                  height: "30px",
                                                  filter:
                                                    "brightness(0) invert(1)",
                                                }}
                                              />
                                            </label>
                                          </>
                                        ) : (
                                          <div
                                            style={{
                                              position: "relative",
                                              width: "50px",
                                              height: "50px",
                                            }}
                                          >
                                            <img
                                              src={
                                                selectedImages[d.id].previewUrl
                                              }
                                              alt={lang.selected}
                                              onClick={(e) =>
                                                handleInputImageClick(
                                                  e,
                                                  selectedImages[d.id]
                                                    .previewUrl,
                                                )
                                              }
                                              style={{
                                                width: "50px",
                                                height: "50px",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                                cursor: "pointer",
                                              }}
                                            />
                                            <button
                                              onClick={(e) =>
                                                handleRemoveImage(e, d.id)
                                              }
                                              style={{
                                                position: "absolute",
                                                top: "3px",
                                                right: "3px",
                                                backgroundColor: "white",
                                                border: "none",
                                                borderRadius: "3px",
                                                width: "15px",
                                                height: "15px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                                padding: 0,
                                              }}
                                            >
                                              <IoClose
                                                size={16}
                                                color="black"
                                              />
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                      <Button
                                        onClick={() => handlePostComment(d.id)}
                                        disabled={postingComment[d.id]}
                                        style={{
                                          backgroundColor: "black",
                                          color: "white",
                                          border: "none",
                                          borderRadius: "8px",
                                          padding: "6px 10px",
                                          fontSize: "14px",
                                          fontWeight: "500",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                        }}
                                      >
                                        {postingComment[d.id] ? (
                                          <Spinner
                                            animation="border"
                                            size="sm"
                                          />
                                        ) : (
                                          lang.post
                                        )}
                                      </Button>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </Collapse>
                      </Card.Body>
                    </Card>
                  ))}

                  {/* Load More Button */}
                  {hasMore && (
                    <div className="text-center mt-4 mb-4">
                      <Button
                        variant="link"
                        onClick={handleLoadMore}
                        disabled={loadingMore}
                        className="text-decoration-none responsive-text"
                        style={{
                          color: "#00adc4",
                          backgroundColor: "white",
                          border: "1px solid #e9ecef",
                          padding: "8px 16px",
                          borderRadius: "12px",
                          fontWeight: "700",
                        }}
                      >
                        {loadingMore ? (
                          <>
                            <Spinner
                              animation="border"
                              size="sm"
                              className="me-2"
                            />
                            {lang.loading || "Loading..."}
                          </>
                        ) : (
                          lang.load_more_discussions
                        )}
                      </Button>
                    </div>
                  )}

                  {/* No More Items Message */}
                  {!hasMore && discussions.length > 0 && (
                    <div className="text-center mt-4 mb-4">
                      <p
                        className="responsive-text"
                        style={{ color: "#6c757d", fontWeight: "500" }}
                      >
                        {lang.no_more_discussions ||
                          "No more discussions to load"}
                      </p>
                    </div>
                  )}
                </>
              )}
            </div>
            {/* ── END CONTENT AREA ── */}
          </div>
        </div>

        {/* Ask Question Modal */}
        <AskQuestionModal
          isOpen={askQuestionModal}
          onClose={handleCloseAskQuestion}
          questionTitle={questionTitle}
          setQuestionTitle={setQuestionTitle}
          questionDescription={questionDescription}
          setQuestionDescription={setQuestionDescription}
          onSubmit={handleSubmitQuestion}
          submitting={submittingQuestion}
          lang={lang}
        />

        {/* Image Preview Modal */}
        <Modal
          show={showImageModal}
          onHide={handleCloseModal}
          centered
          size="lg"
          contentClassName="border-0"
          animation={false}
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <Modal.Body
            className="p-0"
            style={{
              backgroundColor: "transparent",
              border: "none",
            }}
          >
            <div style={{ position: "relative" }}>
              <img
                src={modalImageUrl}
                alt="Preview"
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "80vh",
                  objectFit: "contain",
                  borderRadius: "8px",
                }}
              />
            </div>
          </Modal.Body>
        </Modal>

        {/* Delete Confirmation Modal */}
        <DeleteConfirmModal
          isOpen={deleteModalOpen}
          onClose={handleCloseDeleteModal}
          onConfirm={handleConfirmDelete}
          isDeleting={isDeleting}
        />

        {/* Comment Delete Confirmation Modal */}
        <DeleteCommentConfirmModal
          isOpen={commentDeleteModalOpen}
          onClose={handleCloseCommentDeleteModal}
          onConfirm={handleConfirmCommentDelete}
          isDeleting={isDeletingComment}
        />

        {/* Purchase Popup Modal */}
        <PurchasePopup
          data={courseData}
          isOpen={purchaseModal}
          courseId={course_id}
          toggle={() => setPurchaseModal(!purchaseModal)}
          price={courseData?.price?.toString() || "0"}
          handlePurchase={() => {
            setPurchaseModal(false);
            toast.info("Please purchase the course from the course detail page", {
              position: "top-right",
              autoClose: 3000,
            });
          }}
        />

        <style>{`
          .responsive-container {
            width: 100%;
            max-width: 1600px;
            margin-left: auto;
            margin-right: auto;
            padding-left: 1rem;
            padding-right: 1rem;
          }

          @media (min-width: 640px) {
            .responsive-container {
              padding-left: 1.5rem;
              padding-right: 1.5rem;
            }
          }

          @media (min-width: 768px) {
            .responsive-container {
              padding-left: 2rem;
              padding-right: 2rem;
            }
          }

          @media (min-width: 1024px) {
            .responsive-container {
              padding-left: 3rem;
              padding-right: 3rem;
            }
          }

          @media (min-width: 1280px) {
            .responsive-container {
              padding-left: 4rem;
              padding-right: 4rem;
            }
          }

          @media (min-width: 1536px) {
            .responsive-container {
              padding-left: 5rem;
              padding-right: 5rem;
            }
          }

          .responsive-section-title {
            font-size: clamp(1.3rem, 3vw, 1.8rem);
          }

          .responsive-subsection-title {
            font-size: clamp(0.9rem, 2vw, 1rem);
          }

          .responsive-text {
            font-size: clamp(0.85rem, 1.5vw, 1rem);
          }

          .responsive-small-text {
            font-size: clamp(0.75rem, 1.2vw, 0.85rem);
          }

          /* REFINED SHIMMER - Only boxes animate, proper widths */
          .shimmer-box {
            background: #e0e0e0;
            position: relative;
            overflow: hidden;
          }

          .shimmer-box::after {
            content: "";
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              90deg,
              transparent,
              rgba(255, 255, 255, 0.6),
              transparent
            );
            animation: shimmer 1.5s infinite;
          }

          @keyframes shimmer {
            0% {
              left: -100%;
            }
            100% {
              left: 100%;
            }
          }

          /* Hide webkit scrollbar */
          ::-webkit-scrollbar {
            display: none;
          }

          /* Hide scrollbar in Firefox */
          * {
            scrollbar-width: none;
          }
        `}</style>
      </div>
    </>
  );
}